const DATE_FORMATTER = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const TIME_FORMATTER = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
});

const NUMBER_FORMATTER = new Intl.NumberFormat(undefined);
const COMPACT_NUMBER_FORMATTER = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const RELATIVE_TIME_FORMATTER = new Intl.RelativeTimeFormat(undefined, {
  numeric: 'auto',
});

function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = toDate(value);
  return date ? DATE_FORMATTER.format(date) : 'Not recorded';
}

export function formatDateTime(value) {
  const date = toDate(value);
  return date ? DATE_TIME_FORMATTER.format(date) : 'Not recorded';
}

export function formatTime(value) {
  const date = toDate(value);
  return date ? TIME_FORMATTER.format(date) : '--:--';
}

export function formatRelativeTime(value) {
  const date = toDate(value);
  if (!date) return 'Not recorded';

  const diffMs = date.getTime() - Date.now();
  const diffMinutes = Math.round(diffMs / 60000);
  const diffHours = Math.round(diffMs / 3600000);
  const diffDays = Math.round(diffMs / 86400000);

  if (Math.abs(diffMinutes) < 60) {
    return RELATIVE_TIME_FORMATTER.format(diffMinutes, 'minute');
  }
  if (Math.abs(diffHours) < 48) {
    return RELATIVE_TIME_FORMATTER.format(diffHours, 'hour');
  }
  return RELATIVE_TIME_FORMATTER.format(diffDays, 'day');
}

export function formatCompactNumber(value) {
  return COMPACT_NUMBER_FORMATTER.format(Number(value || 0));
}

export function formatNumber(value) {
  return NUMBER_FORMATTER.format(Number(value || 0));
}

export function formatPercent(value) {
  const numeric = Number(value || 0);
  return `${numeric}%`;
}

export function formatDaysLabel(days) {
  if (days == null || Number.isNaN(Number(days))) return 'No renewal date';
  const numeric = Number(days);
  if (numeric < 0) return `${Math.abs(numeric)} day${Math.abs(numeric) === 1 ? '' : 's'} overdue`;
  if (numeric === 0) return 'Due today';
  return `${numeric} day${numeric === 1 ? '' : 's'} left`;
}

export function formatBytesToMb(value) {
  const numeric = Number(value || 0);
  return `${(numeric / (1024 * 1024)).toFixed(1)} MB`;
}
